import { useDropzone } from "react-dropzone";
import { Label, ToolTipV1 } from "lib";
import { useState, useEffect, useMemo, useCallback } from "react";
import ProgressBar from "lib/Upload/components/documentprogress";
import ImageUpload from "../../assets/images/image_upload.svg";
import Image from "../Image";
import { useDispatch } from "react-redux";
import { uploadMultipleDocument, removeUserDocument, previewUploadedDocument } from "api/formDisplay";
import ErrorMessage from "lib/ErrorMessage";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { setFetchedDocument, setFileData, setMultipleFileUpload, setResponseObject, setUploadedDocument } from "redux/uploadDocumentReducer";
import Toast from "components/ToastComponent";
import Modal from "lib/DocumentViewer/Modal";
import LoadingSpinner from "lib/LoadingSpinner";
import { BASE_URL } from "constants/routes";
import { PDFDocument } from 'pdf-lib';

const MultipleFileUpload = (props) => {
  const {
    label,
    enum: enums,
    tooltip,
    name,
    error,
    clearFieldError,
    selectedData,
    setSelectedData,
    size,
    isEditable,is_disabled,
    validators,
    maxSize,
    isUserInitiated,
    type,
    error_messages
  } = props;

  const [uploaded, setUploaded] = useState(false);
  const [fileName, setFileName] = useState();
  const [fileSize, setFileSize] = useState();
  const [invalidError, setInvalidError] = useState("");
  const [messageToast, setMessageToast] = useState({type:"",msg:""});

  const isAutofilled = useSelector(state => state.uploadDocumentReducer?.isAutofilled)
  const documents = useSelector(state => state.uploadDocumentReducer?.documents)
  const uploadedDocuments = useSelector(state => state.uploadDocumentReducer?.uploadedDocument)
  const fileData = useSelector(state => state.uploadDocumentReducer?.fileData)
  const multipleFileUpload = useSelector(state => state?.uploadDocumentReducer?.multipleFileUpload)
  const organisationId = useSelector(state => state.configurationReducer.config?.organisation_id);
  const dispatch = useDispatch();
  const params = useParams();
  const decryptedId = useSelector((state) => state.urlEncryption?.urlId)
  const subWfId = useSelector((state) => state.dashboardDetailReducer?.currentSubWorkFlowId)
  const maxSizeInMb = Math.ceil(maxSize / (1024 * 1024)); 


  let newArr = []
  let maxCount = []
  let newCount = 0;

  documents && Object?.keys(documents)?.forEach(key => {
    if ((key[key.length - 2] == "-" && name == key.slice(0, key.length - 2)) || (key[key.length - 3] == "-" && name == key.slice(0, key.length - 3))) {
      maxCount = key.split("-")
      newCount = Math.max(parseInt(maxCount[1]))
      newArr.push({ name: key, doc: documents[key] })
    }
  })

  const userInfo = {
    userId: decryptedId.userId,
    primaryWorkflowId: decryptedId.primaryWorkflowId,
    subWfId: decryptedId.subWfId,
    organisationId
  };



let count = 1, docName;
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: enums,
    maxSize: maxSize,
    onDrop: async (acceptedFiles, rejectedFiles) => {
      const newDoc = acceptedFiles.map(async (file, index) => {
        let acceptedFile = {
          file: file,
          file_path: file.path,
          file_size: file.size,
        };

        try {
          if (file?.type === "application/pdf" && validators?.orientation_allowed == "portrait") {
            const fileReader = new FileReader();
            fileReader.onloadend = async () => {
              try {
                const arrayBuffer = await file.arrayBuffer();
                const pdf = await PDFDocument.load(arrayBuffer);
                const pageCount = pdf.getPageCount();
                let isValidSize = true;

                for (let i = 0; i < pageCount; i++) {
                  const page = pdf.getPage(i);
                  const { width, height } = page.getSize();

                  if (!(width >= 580 && width <= 615 && height >= 790 && height <= 899)) {
                    console.log(`Invalid page ${i + 1}: width=${width}, height=${height}`);
                    isValidSize = false;
                    break;
                  }
                }
                if (isValidSize) {
                  if (fileData[name] && fileData[name].length >= 15) {
                    setMessageToast({ type: "error", msg: "Can't upload more than 15 files" });
                    setTimeout(() => {
                      setMessageToast(null);
                    }, 3000);
                  } else {
                    if (fileData[name]?.includes(acceptedFile?.file_path)) {
                      setMessageToast({ type: "error", msg: "Can't upload the same file" });
                      setTimeout(() => {
                        setMessageToast(null);
                      }, 3000);

                    } else {
                      count = (fileData[name] ? fileData[name].length : 0) + index + 1;
                      docName = name + "-" + count;
                      dispatch(setMultipleFileUpload({ acceptedFile }));
                      dispatch(setSelectedData({ key: name, value: " " }));
                      dispatch(setFileData({ key: name, value: acceptedFile?.file_path }));
                      dispatch(uploadMultipleDocument({
                        acceptedFile,
                        name: docName,
                        userInfo,
                        label,
                        setSelectedData,
                        multipleFileUpload
                      }));
                    }
                  }
                } else {
                  setMessageToast({ type: "error", msg: error_messages?.orientation_error });
                  setTimeout(() => {
                    setMessageToast(null);
                  }, 2000);
                }
              } catch (err) {
                console.error("Error reading PDF file:", err);
              }
            };
            fileReader.readAsArrayBuffer(file);
          } else {
            if (fileData[name]?.length >= 15) {
              setMessageToast({ type: "error", msg: "Can't upload more than 15 files" });
              setTimeout(() => {
                setMessageToast(null);
              }, 3000);

            } else if (fileData[name]?.includes(acceptedFile?.file_path)) {
              setMessageToast({ type: "error", msg: "Can't upload same file" });
              setTimeout(() => {
                setMessageToast(null);
              }, 3000);
            } else {
              count = (fileData[name] ? fileData[name].length : 0) + index + 1;
              docName = name + "-" + count;
              dispatch(setFileData({ key: name, value: acceptedFile?.file_path }));
              dispatch(setMultipleFileUpload({ acceptedFile }));
              dispatch(setSelectedData({ key: name, value: " " }));
              dispatch(uploadMultipleDocument({
                acceptedFile,
                name: docName,
                userInfo,
                label,
                setSelectedData,
                multipleFileUpload
              }));
            }
          }
        } catch (err) {
          console.error("Error during upload:", err);
        }
      });
      try {
        await Promise.all(newDoc);
      } catch (error) {
        console.error('Error processing files:', error);
      }
      clearFieldError(name);
    },
    onDropRejected: (rejectedFiles) => {
      setUploaded(true);
      setFileName(null);
      setMessageToast({ type: "error", msg: rejectedFiles[0].errors[0].message });

      setTimeout(() => {

        setMessageToast(null);

      }, 3000);

    },

  });



  const acceptedFile = acceptedFiles.map((file) => {
    let fileData = {
      file: file,
      file_path: file.path,
      file_size: file.size,
    };
    return fileData;
  });

  const removeDocument = (name, documents) => {
    let newDoc = { ...documents }
    let newUploadedDocument = {...uploadedDocuments}
    Object.keys(newDoc).forEach(key => {
      if (name == key) delete newDoc[key]
    })
    if(Object.keys(uploadedDocuments).length){
      Object.keys(newUploadedDocument).forEach(key => {
        if(name == key) delete newUploadedDocument[key]
      })
      dispatch(setUploadedDocument(newUploadedDocument))
    }
    dispatch(setFetchedDocument(newDoc))
  }
  
  const removeFiles = (id) => {
    Object.keys(documents).forEach(key => {
      if (id == key) {
        dispatch(removeUserDocument({ fileData, userInfo, setSelectedData, objName: name, name: key, uploadedDocument: { [key]: documents[key] }, type }));
        acceptedFiles.length = 0;
        acceptedFiles.splice(0, acceptedFiles.length);
        setFileName(null);
        setFileSize(null);
        setUploaded(true);
        setInvalidError(false);
      }

    })
    removeDocument(id,documents)
  };

  const cancelClick = () => {
    removeFiles();
  };

  useEffect(() => {
    const uploadedFile = acceptedFile?.[0];
    if (uploadedFile) {
      const { file_path, file_size } = uploadedFile;
      setFileName(file_path);
      setFileSize(file_size);
    }
  }, [acceptedFile]);

  useEffect(() => {
    if (newArr.length) {
      setUploaded(true);
      newArr.map((item) => {
        dispatch(setFileData({key: name, value: item?.doc?.original_name}))
      })
    }else setUploaded(false)
  }, []);

  const getEnum = () => {
    let enumArray = [];
    if (Array.isArray(enums)) {
      enumArray = enums;
    } else {
      enumArray = Object.keys(enums).map((key) => {
        return key.split("/")[1];
      });
    }
    return enumArray;
  };

  const [showModal, setShowModal] = useState(false);
  const [resp,setResp] = useState();
  const [loading,setLoading] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  
  const previewImage = async(id) => {
    setLoading(true)
    Object.keys(documents).forEach(async(key) => {
      if (id == key) {
        let data = {
          extension: documents[`${key}`]?.document_type,
          document_type: key,
          uploaded_at: documents[`${key}`]?.uploaded_at,
          original_name: documents[`${key}`]?.original_name,
          file_size: documents[`${key}`]?.file_size,
          encrypted_filename: documents[`${key}`]?.encrypted_filename,
          field_label: documents[`${key}`]?.field_label,
          original_filename: documents[`${key}`]?.original_filename,
          organisation_id: organisationId,
          _id: decryptedId?.subWfId ? decryptedId?.subWfId : subWfId
        }
        setIsPdf(data.extension === ".pdf" || data.extension === ".PDF")
        const imageSrc = `${BASE_URL}/workflow/previewUploadedDocument/${data.organisation_id}/${data._id}/${data.document_type}/${data.encrypted_filename}/${data.original_name}`;
        if(imageSrc !== null){
          setResp(imageSrc)
          setLoading(false)
          setShowModal(true)
        } else {
          setLoading(false)
          setMessageToast({type: "error",msg:"Something went wrong, unable to view file"});
        }
      }
    })
  };
  
  return (
    <>
      {loading && <LoadingSpinner/>}
      {showModal && (
            <Modal
              show={true}
              imgSrc={resp}
              setShowModal={setShowModal}
              isPdf={isPdf}
              loadingStatus={resp}
            />
          )}
      {messageToast?.msg && <Toast message={messageToast?.msg} type={messageToast?.type} />}

      <Label image={true} htmlFor="upload" label={label} tooltip={tooltip} validators={validators}/>
      <div className={size}>
        <div
           className={`${ !isEditable && "radioDisabled"} ${
                      !error ? "file-uploader" : "file-uploader error"
                    } px-3 px-md-0 pe-none`}
        >
          <Image imageSrc={ImageUpload} alt="" />

          { isEditable || isUserInitiated ? (
         <div  {...getRootProps({ className:"dropzone" })}>
           <input {...getInputProps({ className:"dropzone" })} />
           <p > Drag and drop or <span className="pe-auto">browse</span> files in {getEnum().join(", ")} format. Add upto 15 attachments each less than {maxSizeInMb}MB.</p>
         </div>
       ) :
       <div className="dropzone" {...getRootProps({ onClick: e => e.stopPropagation() } )}>
         <p> Drag and drop or <span className="pe-auto">browse</span> from system upto {maxSizeInMb}MB|{" "}
                 {getEnum().join(",")}
               </p>
               </div>
      
       }

        </div>
        {newArr ? (newArr?.map(item => {
          return (
            <div className="dropzone">{
              !uploaded && !fileName ? "" :
                <div className=".file-uploaded multiple_files container-fluid border border-2 border-dashed">
                  <ProgressBar
                    fileName={item?.doc?.original_name}
                    fileSize={item?.doc?.file_size}
                    uploaded={uploaded}
                    cancelClick={cancelClick}
                    removeFiles={() => removeFiles(item?.name)}
                    error={invalidError}
                    isEditable={isEditable}
                    is_disabled={is_disabled}
                    previewImage={() => previewImage(item?.name)}
                  />
                </div>
            }

            </div>
          )
        })) : ""}
      </div>
      {error?.length !== 0 && <ErrorMessage error={error} />}
    </>
  );
};


export default MultipleFileUpload